import { UserHelper } from '@/helpers/user.helper';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { RealProperty, UsersService, UserSummaryDetail } from '@eemo/api-client';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ContactDialogComponent, ContactDialogData } from '../contact-dialog/contact-dialog.component';
import { ImgDisplayComponent } from '../img-display/img-display.component';

@Component({
  selector: 'app-referent',
  templateUrl: './referent.component.html',
  styleUrls: ['./referent.component.scss'],
  standalone: true,
  imports: [MatCardModule, ImgDisplayComponent, MatButtonModule, TranslateModule]
})
export class ReferentComponent implements OnInit, OnChanges, OnDestroy {
  @Input() type: 'referent' | 'notary' = 'referent';
  @Input() prop: RealProperty;

  sub = new Subscription();
  user: UserSummaryDetail;

  title: string;
  text: string;
  subTitle: string;
  initials: string;
  email: string;
  companyName: string;

  constructor(private dialog: MatDialog, private usersService: UsersService) {}

  ngOnInit(): void {
    this.text = this.type === 'notary' ? 'notary.text' : 'referent.text';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.prop && changes.prop.currentValue) {
      this.handler(this.type === 'notary' ? this.prop.details?.notary : this.prop.details?.referent);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  handler(user: UserSummaryDetail) {
    this.user = user;
    this.title = UserHelper.userSummmaryDisplayName(this.user);
    this.subTitle = '';
    this.initials = UserHelper.getUserSummaryInitials(this.user);
    this.companyName = user?.companyName || '--';
  }

  doContact(name: string, email: string) {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const data: ContactDialogData = { type: this.type, prop: this.prop, targetName: name, targetEmail: email };
      const dialogRef = this.dialog.open(ContactDialogComponent, {
        // width: '20rem'
        data
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
        }
      });
    }
  }
}
